import { useEffect, useState } from 'react';
import HandleChange from '../../../../../Helpers/HandleChange';
import { FOODIE_DEPARTMENT } from '../Models/Model';
import { toast } from 'react-toastify';
import {
    CreatesFoodieDepartment,
    GetFoodieDepartmentById,
    UpdateFoodieDepartment
} from '../../../../../reduxToolkit/Foodie/FoodieApi';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { GetAllDepartments } from '../../../../../reduxToolkit/DocumentPanel/DocumentPanelApi';
import { errorMsg, isEndTimeAfterStartTime } from "../../../../../Apis/functions";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param event onHide: handle to close modal
 * @param useState setItemSelect: useState for assign data
 */
const AddEditDeptScheduleApp = ({ onHide, itemSelect }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [disabled, setDisabled] = useState(false);
    const [emptyFields, setEmptyFields] = useState(false);
    const [isValidTime, setIsValidTime] = useState(true);
    const [item, setItem] = useState({ ...FOODIE_DEPARTMENT });
    const { handleChange } = HandleChange({ model: item, setModel: setItem });

    const [isValidMealTime, setIsValidMealTime] = useState(true);
    const [isValidFoodsPerDay, setIsValidFoodsPerDay] = useState(true);


    /**
     * Dispatch action to get all foodie departments
     */
    useEffect(() => {
        dispatch(GetAllDepartments())
    }, []);


    /**
     * Validation of mealtime minutes and authorized meals
     */
    useEffect(() => {
        setIsValidMealTime(item.validateMealTime());
        setIsValidFoodsPerDay(item.validateFoodsPerDay());
    }, [item.mealTime, item.foodsPerDay]);

    /**
     * Dispatch action to get by id foodie department
     */
    useEffect(() => {
        if (itemSelect?.id) {
            dispatch(GetFoodieDepartmentById(itemSelect?.id)).then(({ payload: { data: { data } } }) => {
                if (data.id)
                    setItem({ ...FOODIE_DEPARTMENT, ...data })

            });
        }
    }, [itemSelect]);

    /**
     * useEffect to validate dates.
     */
    useEffect(() => {
        if (item?.startShiftAt && item?.endShiftAt) {
            setIsValidTime(isEndTimeAfterStartTime(item?.startShiftAt, item?.endShiftAt))
        }
    }, [item?.startShiftAt, item?.endShiftAt]);

    /**
     * handle to cotrol add o edit
     */
    const handleAddEdit = () => {
        const isNew = !item.id;

        const isInvalid = !item.isValid() || (!item.departmentId && isNew) || !isValidTime || !isValidMealTime || !isValidFoodsPerDay;

        if (isInvalid) {
            setEmptyFields(true);
            return;
        }
        setEmptyFields(false);
        const body = item.toAddEdit();
        isNew ? handleCreate(body) : handleUpdate(body);
    };


    /**
     * handle to create privilege
     * @param body
     */
    const handleCreate = (body) => {
        dispatch(CreatesFoodieDepartment(body)).then(({ payload: { data: { success, code } } }) => {
            if (success === true) {
                onHide();
                toast.success(t('has_been_created_successfully'));
            } else errorMsg(code)
        });
    };

    /**
     * handle to edit privilege
     * @param body
     */
    const handleUpdate = (body) => {
        dispatch(UpdateFoodieDepartment(body)).then(({ payload: { data: { success, code } } }) => {
            if (success === true) {
                onHide();
                toast.success(t('has_been_updated_successfully'));
            } else errorMsg(code)
        });
    };

    /**
     * Function to clean fields
     */
    const clearField = () => {
        setItem({ ...FOODIE_DEPARTMENT })
    }

    return {
        t,
        item,
        setItem,
        handleChange,
        handleAddEdit,
        clearField,
        disabled,
        emptyFields,
        isValidTime,
        isValidMealTime,
        isValidFoodsPerDay,
    }

}

export default AddEditDeptScheduleApp;
